export default __webpack_public_path__ + "static/media/creddit-icon.808dd2f6.png";